module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/LcBE7q/tc-custom/9781439678572.jpg?1705539782549",
      "alt": "This image is the cover for the book Dayton Ghosts & Legends, Haunted America"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Dayton Ghosts & Legends, Haunted America\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v(" Every city has its odd and scary side, and Dayton is no exception. ")])]), _vm._v(" "), _c('p', [_vm._v("The ghost of Paul Sorg still sits in his favorite seat in the Sorg Opera House more than a hundred years after his death. The so-called phantom terrorized truck drivers crossing the Englewood Dam before disappearing for good. The famed Butter Street Monster roams Germantown. Magee Park is home to numerous bigfoot and ghost sightings--and even a unicorn sighting. A building of many names, the tower on Patterson Boulevard in Kettering near Hills and Dales Park has been the source of many stories for generations, but only now is its true story finally told.")]), _vm._v(" "), _c('p', [_vm._v("Dayton native, author, and host of the Dayton Unknown blog Sara Kaushal leads a chilling tour of Gem City's strange and unusual history.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sara K. Kaushal\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Sara Kaushal is a Dayton historian, the author of Murder & Mayhem in Dayton and the Miami Valley and the primary author of the blog Dayton Unknown . She loves historic true crime, mysteries and ghost stories and can't drive through Dayton without pointing out at least one haunted place. She has a bookshelf full of books she intends to read one day, when she's not researching or writing. Sara can be contacted for events and questions at authorsarakaushal@gmail.com.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    History Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0